<template>
  <div class="container">
    <div class="flex_space_between search_box">
      <div class="flex_start">
        <div class="flex_start_center mr_24">
          <div class="mr_12">设备CCID：</div>
          <div>
            <el-input placeholder="请输入" v-model="searchForm.ccid"></el-input>
          </div>
        </div>
        <div class="flex_start_center mr_24">
          <div class="mr_12">床位号：</div>
          <div>
            <el-input placeholder="请输入" v-model="searchForm.bed_number"></el-input>
          </div>
        </div>
        <div class="flex_start_center mr_24">
          <div class="mr_12">患者住院号：</div>
          <div>
            <el-input placeholder="请输入" v-model="searchForm.patient_id"></el-input>
          </div>
        </div>
        <el-button type="primary" @click="search">查询</el-button>
        <el-button type="warning" @click="reset">重置</el-button>
      </div>
    </div>
    <el-table :data="tableData" v-loading="loading" align="center" border>
      <el-table-column prop="ccid" label="设备CCID号" align="center"></el-table-column>
      <el-table-column prop="patient_id" label="住院号" align="center"></el-table-column>
      <el-table-column prop="bed_number" label="床位号" align="center"></el-table-column>
      <el-table-column prop="name" label="患者姓名" align="center"></el-table-column>
      <el-table-column prop="bind_time" label="绑定时间" align="center">
        <template slot-scope="scope">
          {{ $dateFtt.dateFtt("yyyy-MM-dd hh:mm:ss", new Date(scope.row.bind_time * 1000)) }}
        </template>
      </el-table-column>
      <el-table-column prop="unbind_time" label="解绑时间" align="center">
        <template slot-scope="scope">
          {{ Number(scope.row.unbind_time) ? $dateFtt.dateFtt("yyyy-MM-dd hh:mm:ss", new
            Date(scope.row.unbind_time * 1000)):"--"}}
        </template>
      </el-table-column>
    </el-table>

    <div class="block">
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="page"
        :page-sizes="[10, 15, 20, 25]" :page-size="perPage" layout="total, sizes, prev, pager, next, jumper"
        :total="total"></el-pagination>
    </div>

  </div>
</template>

<script>
export default {
  data() {
    return {
      searchForm: {
        ccid: "",
        bed_number: "",
        patient_id: "",
      },
      page: 1,
      perPage: 10,
      total: 0,
      tableData: [],
      loading: false,
      zone_number: "",
    };
  },

  mounted() {
    if (!this.$cookies.get("token")) {
      this.$router.push("/login");
    }
    this.zone_number = this.$cookies.get("zone_number");
    this.fetchData();
  },

  methods: {
    reset() {
      this.searchForm.bed_number = "";
      this.searchForm.patient_id = "";
      this.searchForm.ccid = "";
      this.page = 1;
      this.fetchData();
    },
    search() {
      this.page = 1;
      this.fetchData();
    },
    handleSizeChange(e) {
      this.perPage = e;
      this.page = 1;
      this.fetchData();
    },
    handleCurrentChange(e) {
      this.page = e;
      this.fetchData();
    },
    fetchData() {
      this.loading = true;
      let data = {
        page: this.page,
        perPage: this.perPage,
        zone_number: this.zone_number,
        bed_number: this.searchForm.bed_number,
        patient_id: this.searchForm.patient_id,
        ccid: this.searchForm.ccid,
      };
      this.$http({
        url: "/api/device_log/list",
        method: "GET",
        params: data,
        headers: {
          Token: this.$cookies.get("token"),
        },
      }).then((res) => {
        const result = res.result;
        this.tableData = result.data;
        this.total = result.total;
        this.loading = false;
      });
    },
  },
};
</script>
<style scoped></style>


// WEBPACK FOOTER //
// src/view/managePages/device_log.vue